export default "__VITE_ASSET__DTg7PAR7__"